<style>
.zoezi-my-teamsport-registrations .v-expansion-panel-header {
    padding: 8px 8px;
}
</style>

<template>
    <div>
        <h1>{{ $translate('Current participation') }}</h1>
        <div v-if="!registrations.length">
            <v-card>
                <v-card-text>
                    {{$translate('You have no current participations')}}
                </v-card-text>
            </v-card>
        </div>
        <div v-else>
            <v-expansion-panels v-model="expandedPanel">
                <v-expansion-panel v-for="registration in registrations" :key="registration.id" class="my-2">
                    <v-expansion-panel-header color="primary" class="primarytext--text" expand-icon="">
                        <template #default="{open}">
                            <div class="d-flex align-center justify-center">
                                <template v-if="registration.group">
                                    <v-avatar size="40" class="mr-2" v-if="registration.group">
                                        <img :src="$api.getImageUrl(registration.group.imagekey, 200)" style="background: white" />
                                    </v-avatar>
                                    <div class="flex-grow-1">{{registration.group.name}}</div>

                                    <div class="d-flex flex-column">
                                        <div>{{registration.competition.name}} {{registration.gameclass.name}}</div>
                                        <div>
                                            <a :href="getDivisionPage(division)" @click.prevent="gotoDivision(division)" v-for="division in registration.divisions" :key="division.id">
                                                {{division.name}}
                                            </a>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <!-- For individual competitions - use sport image -->
                                    <v-avatar size="40" class="mr-2">
                                        <img :src="'/api/public/image/get?size=200x200&type=teamsport&id=' + registration.teamsport.id" />
                                    </v-avatar>
                                    <div class="d-flex flex-column flex-grow-1">
                                        <div class="d-flex flex-row">
                                            <div v-if="registration.user_id != $store.state.user.id">, {{registration.user.name}}</div>
                                        </div>
                                        <div v-if="registration.competition.startDate == registration.competition.endDate" style="font-size: smaller">
                                            {{Date.formatFullShorter(registration.competition.startDate).capitalize()}}
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column">
                                        <div>{{registration.competition.name}} {{registration.gameclass.name}}</div>
                                        <div>
                                            <a href="getDivisionPage(division)" @click.prevent="gotoDivision(division)" v-for="division in registration.divisions" :key="division.id">
                                                {{division.name}}
                                            </a>
                                        </div>
                                    </div>
                                </template>
                                <v-icon class="primarytext--text ml-8" v-if="open">mdi-chevron-up</v-icon>
                                <v-icon class="primarytext--text ml-8" v-else>mdi-chevron-down</v-icon>
                            </div>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="z-dense">
                        <template v-if="registration.gameclass.one_match">
                            <teamsport-one-match :registration="registration" />
                        </template>
                        <v-row v-else>
                            <v-col cols="12" md="6">
                                <teamsport-next-match :teamId="registration.id" />
                                <teamsport-previous-match :teamId="registration.id" class="mt-4"/>
                            </v-col>
                            <v-col cols="12" md="6">
                                <teamsport-coming-matches :teamId="registration.id" />
                                <teamsport-team-management :registration="registration" class="mt-4" v-if="!registration.gameclass.individual"/>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <!-- historic registrations -->
        <div class="mt-2">
            <div v-if="historicRegistrations && !historicRegistrations.length && !loading">
                <h1>{{ $translate('Historical participation') }}</h1>
                <v-card>
                    <v-card-text>
                        {{$translate('You have no historic participations')}}
                    </v-card-text>
                </v-card>
            </div>
            <div v-else-if="historicRegistrations && historicRegistrations.length">
                <h1>{{ $translate('Historical participation') }}</h1>
                <v-expansion-panels v-model="expandedPanelHistoric">
                    <v-expansion-panel v-for="registration in historicRegistrations" :key="registration.id" class="my-2">
                        <v-expansion-panel-header color="primary" class="primarytext--text" expand-icon="">
                            <template #default="{open}">
                                <div class="d-flex align-center justify-center">
                                    <template v-if="registration.group">
                                        <v-avatar size="40" class="mr-2" v-if="registration.group">
                                            <img :src="$api.getImageUrl(registration.group.imagekey, 200)" style="background: white" />
                                        </v-avatar>
                                        <div class="flex-grow-1">{{registration.group.name}}</div>

                                        <div class="d-flex flex-column">
                                            <div>{{registration.competition.name}} {{registration.gameclass.name}}</div>
                                            <div>
                                                <a href="getDivisionPage(division)" @click.prevent="gotoDivision(division)" v-for="division in registration.divisions" :key="division.id">
                                                    {{division.name}}
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- For individual competitions - use sport image -->
                                        <v-avatar size="40" class="mr-2">
                                            <img :src="'/api/public/image/get?size=200x200&type=teamsport&id=' + registration.teamsport.id" />
                                        </v-avatar>
                                        <div class="d-flex flex-column flex-grow-1">
                                            <div class="d-flex flex-row">
                                                <div v-if="registration.user_id && registration.user_id != $store.state.user.id">, {{registration.user.name}}</div>
                                            </div>
                                            <div v-if="registration.competition.startDate == registration.competition.endDate" style="font-size: smaller">
                                                {{Date.formatFullShorter(registration.competition.startDate).capitalize()}}
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div>{{registration.competition.name}} {{registration.gameclass.name}}</div>
                                            <div>
                                                <a href="getDivisionPage(division)" @click.prevent="gotoDivision(division)" v-for="division in registration.divisions" :key="division.id">
                                                    {{division.name}}
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                    <v-icon class="primarytext--text ml-8" v-if="open">mdi-chevron-up</v-icon>
                                    <v-icon class="primarytext--text ml-8" v-else>mdi-chevron-down</v-icon>
                                </div>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="z-dense">
                            <template v-if="registration.gameclass.one_match">
                                <teamsport-one-match :registration="registration" />
                            </template>
                            <v-row v-else>
                                <v-col>
                                    <teamsport-team-management :registration="registration" class="mt-4" v-if="!registration.gameclass.individual"/>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <div v-else>
                <v-btn :loading="loading" outlined @click="getHistoricRegistrations">{{ $translate('Get historic participation') }}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import TeamsportNextMatch from './Teamsport/NextMatch.vue'
import TeamsportPreviousMatch from './TeamsportPreviousMatch.vue'
import TeamsportComingMatches from './TeamsportComingMatches.vue'
import TeamsportTeamManagement from './TeamsportTeamManagement.vue'
import TeamsportOneMatch from './TeamsportOneMatch.vue'
export default {
    name: 'zoezi-my-teamsport-registrations',

    zoezi: {
        title: 'My competitions',
        icon: 'mdi-trophy-variant-outline',
        addon: 'TeamSports'
    },

    props: {
        activeTeam: {
            title: 'Active team',
            type: String,
            default: null
        }
    },

    components: {
        TeamsportNextMatch,
        TeamsportPreviousMatch,
        TeamsportComingMatches,
        TeamsportTeamManagement,
        TeamsportOneMatch,
    },

    watch: {
        expandedPanel() {
            this.setProp('activeTeam', this.registrations[this.expandedPanel]?.id);
        },
        registrations() {
            if (this.activeTeam) {
                this.expandedPanel = this.registrations.findIndex(r => r.id == this.activeTeam);
            }
        }
    },

    computed: {
        registrations() {
            return this.$store.state?.bookings?.teamsportbookings.map(team => {
                const group = team.group_id ? this.visibleGroups.find(g => g.id == team.group_id) : null;
                const user = team.user_id ? this.$store.state.user?.canBookFor?.find(x => x.id == team.user_id) : null;

                return {...team, group, user};
            }).filter(reg => reg.group || reg.user) || [];
        },
        visibleGroups() {
            return this.$store.state?.user?.groups?.filter(g => g.show) ?? [];
        },
    },

    data: () => ({
        expandedPanel: null,
        historicRegistrations: null,
        expandedPanelHistoric: null,
        loading: false
    }),

    methods: {
        getDivisionPage(division) {
            const page = this.$root.siteconfig?.pages?.division;
            const param = this.$root.siteconfig.pages.divisionParamId;
            if (param == 'id') {
                return `${page}/${division.id}`;
            }
            return `${page}?${param}=${division.id}`;
        },
        gotoDivision(division) {
            this.$root.followLink(this.getDivisionPage(division));
        },
        getHistoricRegistrations() {
            this.loading = true;
            let toDate = new Date().monday();
            toDate.setDate(toDate.getDate() - 1);
            this.$api.get('/api/memberapi/teamsport/team/compact/get', { to_date: toDate.dateTime() }).then(res => {
                this.historicRegistrations = res.map(team => {
                    const group = team.group_id ? this.visibleGroups.find(g => g.id == team.group_id) : null;
                    const user = team.user_id ? this.$store.state.user?.canBookFor?.find(x => x.id == team.user_id) : null;

                    return {...team, group, user};
                }).filter(reg => reg.group || reg.user);

                this.loading = false;
            });
        }
    }
}
</script>
